import { render, staticRenderFns } from "./AfterpayLogo.vue?vue&type=template&id=e8ec5aec&"
import script from "./AfterpayLogo.vue?vue&type=script&lang=ts&"
export * from "./AfterpayLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports